import React from "react";

import "../Star.css";

const Star5 = () => {
  return (
    <span>
      <span className="fa fa-star checked"></span>
      <span className="fa fa-star checked"></span>
      <span className="fa fa-star-half-alt"></span>
      <span className="fa fa-star"></span>
      <span className="fa fa-star"></span>
    </span>
  );
};

export default Star5;
